import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  resetClient: ['client'],
  loadClientRequest: ['clientId'],
  setClientData: ['data'],
  setClientLoading: ['loading']
});

export const ClientTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  data: {}
};

/* ------- Selectors --------- */
export const ClientSelectors = {
  selectIsLoading: state => state.client.loading,
  selectClientData: state => state.client.data
};

/* -------- Reducers ---------- */

export const resetClient = (state, { client }) => {
  return {
    ...INITIAL_STATE,
    ...client
  };
};

export const setClientData = (state, { data }) => {
  return {
    ...state,
    data
  };
};

export const setClientLoading = (state, { loading }) => {
  return {
    ...state,
    loading
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_CLIENT]: resetClient,
  [Types.SET_CLIENT_LOADING]: setClientLoading,
  [Types.SET_CLIENT_DATA]: setClientData
});
